const Swal = require('sweetalert2')

const share = () => {

  jQuery(document).ready(function($){
    $(document).on('click','a[data-action]',function(e){

        var $this   = $(this),
            id      = $(this).data("id"),
            clk     = $(this).data("interaction-type"),
            action  = $(this).data("action");

        if(action === 'gd_interaction') {
          if($(this).data("interactionType") !== 'open_contact') {
            if($(this)[0].protocol === 'http:' || $(this)[0].protocol === 'https:') {
              let wi = window.open('about:blank', '_blank');
              wi.location.href = $(this)[0].href;
            }
          }
        }

        if(action === 'like') {
          return;
        }

        jQuery.ajax({
            type: "post",
            url: glamyAjax.ajaxurl,
            data: "action="+action+"&nonce="+glamyAjax.nonce+"&id="+id+"&clk=" + clk,
            success: function(result){

                if(action === 'like') {
                    $this.find('span[data-number]').text(result.data.likes);

                    if(result.data.type === 'add') {
                      $this.addClass('--filled');
                    } else {
                      $this.removeClass('--filled');
                    }
                }

                if(action === 'share') {
                  let socialShareModal = document.getElementById('social-share');
                  const socialLinks = socialShareModal.querySelectorAll('[data-share-type]');
                  if(socialLinks) {
                    Array.prototype.forEach.call(socialLinks, function (link) {
                      if(link.getAttribute('data-share-type') === 'mail') {
                        link.href = result.data.mail;
                      } else if(link.getAttribute('data-share-type') === 'twitter') {
                        link.href = result.data.twitter;
                      } else if(link.getAttribute('data-share-type') === 'facebook') {
                        link.href = result.data.facebook;
                      } else if(link.getAttribute('data-share-type') === 'whatsapp') {
                        link.href = result.data.whatsapp;
                      }
                    });

                    UIkit.modal(socialShareModal).show();
                  }
                }

                if(action === 'bookmark') {

                  if(result.success === false) {
                    Swal.fire({
                      title: result.data.title,
                      text: result.data.msg,
                      icon: 'error',
                      confirmButtonText: result.data.btn,
                      focusConfirm: false,
                      buttonsStyling: false,
                      customClass: {
                        confirmButton: ["c-bttn"],
                      }
                    })
                  } else {
                    if($this.data("bookmark") === 'remove') {
                      var post = $this.parent().parent();
                      post.slideUp(function () {
                        post.remove();
                      });
                    } else {
                      if(result.data.type === 'add') {
                        $this.addClass('--filled');
                      } else {
                        $this.removeClass('--filled');
                      }
                    }

                    if($('.c-slidein-nav__meta__item__badge').length) {
                      $('div[data-bookmark-badge]').text(result.data.count);
                    }

                  }

                }

            },
            error: function(error) {
              console.error(error);
            }

        });

        return false;
    });
  });

};

export default share;
